import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  GetProp,
  Input,
  Modal,
  Select,
  Table,
  TableColumnsType,
  TablePaginationConfig,
  TableProps,
} from "antd";
import { SorterResult } from "antd/es/table/interface";
const OperationData: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  interface TableParams {
    pagination?: TablePaginationConfig;
    sortField?: SorterResult<any>["field"];
    sortOrder?: SorterResult<any>["order"];
    filters?: Parameters<GetProp<TableProps, "onChange">>[1];
  }

  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
      position: ["bottomCenter"],
    },
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  interface DataType {
    billNumber: string;
    date: string;
    hotel: string;
    room: string;
    area: string;
    tour: string;
    exQty: string;
    adult: string;
    child: string;
    infant: string;
    time: string;
    supplier1: string;
    supplier2: string;
    supplier3: string;
    pColl: string;
    remarks: string;
    soldBy: string;
    businessUnit: string;
  }

  const columns: TableColumnsType<DataType> = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
      sorter: true,
      render: (booking_number: string) => `${booking_number}`,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: true,
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      sorter: true,
    },
    {
      title: "Room",
      dataIndex: "room",
      sorter: true,
    },
    {
      title: "Area",
      dataIndex: "area",
      sorter: true,
    },
    {
      title: "Tour",
      dataIndex: "tour",
      sorter: true,
    },
    {
      title: "ExQty",
      dataIndex: "exQty",
      sorter: true,
    },
    {
      title: "Adult",
      dataIndex: "adult",
      sorter: true,
    },
    {
      title: "Child",
      dataIndex: "child",
      sorter: true,
    },
    {
      title: "Infant",
      dataIndex: "infant",
      sorter: true,
    },
    {
      title: "Time",
      dataIndex: "time",
      sorter: true,
    },
    {
      title: "Supplier 1",
      dataIndex: "supplier1",
      sorter: true,
    },
    {
      title: "Supplier 2",
      dataIndex: "supplier2",
      sorter: true,
    },
    {
      title: "Supplier 3",
      dataIndex: "supplier3",
      sorter: true,
    },
    {
      title: "P.coll.",
      dataIndex: "pColl",
      sorter: true,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      sorter: true,
    },
    {
      title: "Sold by",
      dataIndex: "soldBy",
      sorter: true,
    },
    {
      title: "Business Unit",
      dataIndex: "businessUnit",
      sorter: true,
    },
  ];

  const [data, setData] = useState<DataType[]>();

  const dataShare: DataType[] = [
    {
      billNumber: "TS/2501287619",
      date: "24/02/24",
      hotel: "Souk Madnar Jumirah",
      room: "805",
      area: "SZR",
      tour: "Standard Dhow Crulse Marlna-WT",
      exQty: "0",
      adult: "2",
      child: "0",
      infant: "0",
      time: "11:00",
      supplier1: "Supplier Name 1",
      supplier2: "Supplier Name 2",
      supplier3: "Supplier Name 3",
      pColl: "3",
      remarks: "Remarks goes here",
      soldBy: "Vinita Shewkani",
      businessUnit: "Package Website",
    },
  ];

  const [loading, setLoading] = useState(false);
  const handleTableChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const options = [
    { label: "Rayna Tourism", value: "Rayna Tourism" },
    { label: "UEA Tourism", value: "UEA Tourism" },
    { label: "Dubai Tourism", value: "Dubai Tourism" },
  ];

  const handleChange = (value: any) => {
    console.log("Selected:", value);
  };

  return (
    <>
      <Table<DataType>
        columns={columns}
        dataSource={dataShare}
        pagination={tableParams.pagination}
        loading={loading}
        className="fullWidthDataTable"
        onChange={handleTableChange}
        scroll={{ x: 'max-content' }}
      />
      <Form className="w100">
        <Form.Item className="bottomButtonBox w100 mb-0">
          <Button type="primary" onClick={showModal}>
            Assign Supplier
          </Button>
        </Form.Item>
      </Form>

      <Modal
        title="Assign Supplier"
        className="collectionModal textModal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Assign Supplier"
        cancelText="Clear"
      >
        <div>
          <Form
            {...formItemLayout}
            form={form}
            name="horizontal_login"
            onFinish={onFinish}
            className="createCustomerForm mainCardDetailsForm mt-4"
          >
            <Form.Item
              className="cardTextfieldBox residentBox"
              name="Search"
              label="Product Name"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Input placeholder="Product Name" className="searchInputField" />
            </Form.Item>

            <Form.Item
              className="cardTextfieldBox residentBox"
              label="Select Supplier"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Select
                mode="multiple" 
                placeholder="Select Supplier"
                onChange={handleChange}
                options={options}
              />
            </Form.Item>

            <Form.Item
              className="cardTextfieldBox residentBox"
              name="ProductType"
              label="Product Type"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Input placeholder="Product Type" className="searchInputField" />
            </Form.Item>

            <Form.Item
              className="cardTextfieldBox"
              label="Select Service"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Select />
            </Form.Item>

            <Form.Item
              className="cardTextfieldBox"
              label="Remarks"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input placeholder="Remarks" className="searchInputField" />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default OperationData;
